export const hhent = (() => {
    const placeHolderText = 'EOMI/Pharynx and nasal cavity clear'

    return placeHolderText
})